(function (window, document) {
  const markdownToHtml = (markdown) => {
    let html = markdown
      // Escape HTML special characters first
      .replaceAll(
        /[&<>"']/g,
        (char) =>
          ({
            "&": "&amp;",
            "<": "&lt;",
            ">": "&gt;",
            '"': "&quot;",
            "'": "&#39;",
          }[char])
      )
      // Convert bold (handle both ** and __)
      .replaceAll(/(\*\*|__)(.*?)\1/g, "<strong>$2</strong>")
      // Convert italics (handle both * and _)
      .replaceAll(/(\*|_)(.*?)\1/g, "<em>$2</em>")
      // Convert line breaks
      .replaceAll("\\n", "<br/>");

    return html;
  };

  const sanitizeAndFormatHTML = (str) => {
    const div = document.createElement("div");
    div.textContent = str;
    return markdownToHtml(div.innerHTML);
  };

  const fetchData = async () => {
    const DATA_ENDPOINT =
      "https://gacetaqueer-76488-default-rtdb.firebaseio.com/.json";

    const response = await fetch(DATA_ENDPOINT);
    return await response.json();
  };

  const injectData = (dynamicContent) => {
    // Get HTML nodes
    const dialogNode = document.getElementById("custom-dialog");
    const closeDialogNode = document.getElementById("custom-dialog-close");
    const dialogTitleNode = document.getElementById("custom-dialog-title");
    const dialogTextNode = document.getElementById("custom-dialog-text");
    const dialogImgNode = document.getElementById("custom-dialog-img");
    const ctaNode = document.getElementById("custom-dialog-cta");

    const heroTitleNode = document.getElementById("homepage-hero-text-main");
    const heroParagraphNode = document.getElementById(
      "homepage-hero-text-paragraph"
    );

    // Deconstruct object
    const {
      heroTitle,
      heroParagraph,
      showDialog,
      dialogTitle,
      dialogText,
      dialogImage,
      ctaText,
      ctaLink,
    } = dynamicContent;

    // Set content
    if (heroTitle && heroTitleNode) {
      heroTitleNode.setHTMLUnsafe(sanitizeAndFormatHTML(heroTitle));
    }

    if (heroParagraph && heroParagraphNode) {
      heroParagraphNode.setHTMLUnsafe(sanitizeAndFormatHTML(heroParagraph));
    }

    if (Boolean(showDialog) && dialogNode && closeDialogNode) {
      dialogNode.showModal();
      closeDialogNode.addEventListener("click", () => {
        dialogNode.close();
      });

      if (dialogTitle && dialogTitleNode) {
        dialogTitleNode.setHTMLUnsafe(sanitizeAndFormatHTML(dialogTitle));
      }
      if (dialogText && dialogTextNode) {
        dialogTextNode.setHTMLUnsafe(sanitizeAndFormatHTML(dialogText));
      }

      if (dialogImage && dialogImgNode) {
        dialogImgNode.setAttribute("src", dialogImage);
      } else {
        dialogImgNode.style.display = "none";
      }

      if (ctaText && ctaLink && ctaNode) {
        ctaNode.setHTMLUnsafe(sanitizeAndFormatHTML(ctaText));
        ctaNode.addEventListener("click", () => {
          window.location.href = ctaLink;
          dialogNode.close();
        });
      } else {
        ctaNode.style.display = "none";
      }
    }
  };

  const main = async () => {
    try {
      const dynamicContent = await fetchData();
      injectData(dynamicContent);
    } catch (e) {
      console.log(e);
    } finally {
      const loader = document.getElementById("loader-container");
      loader.style.display = "none";
    }
  };

  main();
})(window, document);
